export default "__VITE_ASSET__B_PIGm$w__"